/*
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-08-28 13:44:31
 * @LastEditors: FJW
 * @LastEditTime: 2025-04-10 16:53:36
 */
/*
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-08-28 13:44:31
 * @LastEditors: FJW
 * @LastEditTime: 2024-10-22 09:03:40
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css';
import httpRequest from './api/httpRequest';
import httpShopRequest from './api/httpShopRequest';
import * as socketApi from './api/wssocket';
import emotion from './api/emotion.js';
import element from './api/element.js';
import store from './store';
import * as  enums from './api/enums.js';
import * as  date from './api/date.js';
import './utils/directive/dialogDrag';
import '@/directive/height.js' // 自适应高度指令
import { formatDate } from '@/utils/func.js';

import Pagination from '@/components/common/Pagination';
Vue.component('Pagination', Pagination);

import loading from "@/components/Loading/loading.js"
Vue.prototype.$isLoading = loading

Vue.use(ElementUI);
// 挂载全局
Vue.prototype.$wsApi = socketApi;
Vue.prototype.$date = date;
Vue.prototype.$http = httpRequest // http请求方法
Vue.prototype.$httpShop = httpShopRequest // http请求方法
Vue.prototype.$emo = emotion; // emo表情
Vue.prototype.$elm = element; // 元素操作
Vue.prototype.$enums = enums; // 枚举
Vue.prototype.$dayjs = formatDate; // 枚举
Vue.config.productionTip = false;

new Vue({
  el: '#app',
  // 配置路由
  router,
  store,
  render: h => h(App)
})
